export const SEASONAL=[
  {
    "displayText": "img1",
    "filename": "./assets/img/seasonal/img1.jpeg",
    "link": ""
  },
  {
    "displayText": "img2",
    "filename": "./assets/img/seasonal/img2.jpeg",
    "link": ""
  },
  {
    "displayText": "img3",
    "filename": "./assets/img/seasonal/img3.jpeg",
    "link": ""
  },
  {
    "displayText": "img4",
    "filename": "./assets/img/seasonal/img4.jpeg",
    "link": ""
  },
  {
    "displayText": "img5",
    "filename": "./assets/img/seasonal/img5.jpeg",
    "link": ""
  },
  {
    "displayText": "img6",
    "filename": "./assets/img/seasonal/img6.jpeg",
    "link": ""
  }
]